import {memo} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {
    ClientReportSubmitInput,
    TreatmentOfferedOptionMap
} from "../../domain";
import {SimpleDropdown} from "../../../../common";

type TreatmentOfferedInputProps = {
    sending: boolean;
};
export const TreatmentOfferedInput = memo(({sending}: TreatmentOfferedInputProps) => {
    const {
        setValue,
        clearErrors,
        control,
        formState: {
            errors
        },
    } = useFormContext<ClientReportSubmitInput>();

    return (
        <div className="pb-2">
            <div className="flex w-1/2 text-black-200 pb-2 items-center text-base">
                <div className="w-1/2 text-right">
                    Treatment Offered
                </div>
                <div className="ml-4 flex items-center">
                    <Controller
                        name="treatmentOffered"
                        control={control}
                        rules={{
                            required: true
                        }}
                        render={({field: {value}}) =>
                            <SimpleDropdown
                                options={TreatmentOfferedOptionMap}
                                selected={value}
                                disabled={sending}
                                hasErrorBorder={errors.treatmentOffered !== undefined}
                                setSelected={(selected) => {
                                    setValue("treatmentOffered", selected);
                                    clearErrors("treatmentOffered");
                                }}
                                textColor={"black-200"}
                            />
                        }/>
                </div>
            </div>
            {
                errors.treatmentOffered &&
                <div className="flex">
                    <div className="ml-4 text-red-700">
                        Please indicate if treatment will be provided before submitting a report
                    </div>
                </div>
            }
        </div>
    );
});
